import React from 'react';

/* eslint-disable react/prop-types */
/**
 * @template {import('@tanstack/react-table').RowData} TData
 * @param {{ table: import('@tanstack/react-table').Table<TData> }} props
 */
const DataTableColumnVisibility = ({ table }) => {
  const columns = table.getAllLeafColumns().filter((column) => column.getCanHide());
  if (!columns.length) return null;

  return (
    <details className="relative">
      <summary className="cursor-pointer list-none rounded-md border border-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand">
        Columns
      </summary>
      <div className="absolute right-0 z-20 mt-2 max-h-64 min-w-48 overflow-y-auto rounded-md border border-gray-200 bg-white p-2 shadow-lg">
        {columns.map((column) => (
          <label key={column.id} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
            <input
              type="checkbox"
              checked={column.getIsVisible()}
              onChange={column.getToggleVisibilityHandler()}
              className="h-4 w-4 rounded border-gray-300 text-brand focus:ring-brand"
            />
            <span>{column.id}</span>
          </label>
        ))}
      </div>
    </details>
  );
};

export default DataTableColumnVisibility;
